import Crud from '@/views/TransportationRequest/Crud'
import Add from '@/views/TransportationRequest/Add'

import Approve from '@/views/TransportationRequest/Approve'

const routes = {
  path: '/transportationRequest',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/transport_solicitations',
      name: 'list-solicitation_vt',
      component: Crud,
    },
    {
      path: '/transport_solicitations/add',
      name: 'Solicitação de vale-transporte',
      component: Add,
    },
    {
      path: '/transport_solicitations/edit/:id?',
      name: 'Solicitação de vale-transporte',
      component: Add,
    },
    {
      path: '/transport_solicitations/approve',
      name: 'Aprovar solicitações de vale-transporte',
      component: Approve,
    },
  ],
}

export default routes
